module.exports = __webpack_public_path__ + "static/media/stop.f23f27f2.png";